export const GetWithdrawOrKYC = async (userid: string) =>
  fetch(`/api/public/claims/${userid}/kyc`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((e) => e.json());

export const GetMateriaOnWallet = async (userid: string, networktype: string) =>
  fetch(`/api/public/user/${userid}/materia-balance?network=${networktype}&contract=${process.env.CONTRACT_MATERIA}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((e) => e.json());
